import React, { useState } from "react";
import { AIRTABLE_URL, AIRTABLE_HEADERS } from "./constants";

// Netlify web login file backup
export default function CustomerLogin() {
  const [phone, setPhone] = useState("");
  const [referralBy, setReferralBy] = useState("");
  const [password, setPassword] = useState("");

  // ✅ Handle Submit
  const handleSubmit = async () => {
    if (phone.length === 10 && password.trim() !== "") {
      localStorage.setItem("userPhone", phone);
      await sendToAirtableIfFirstTime(phone, referralBy, password);
      window.location.href = "/home";
    } else {
      alert("Please enter valid phone number and password.");
    }
  };

  // ✅ Airtable Save
  const sendToAirtableIfFirstTime = async (userPhone, referralBy, password) => {
    try {
      const existingUserResp = await fetch(
        `${AIRTABLE_URL}?filterByFormula={phone}="${userPhone}"`,
        { headers: AIRTABLE_HEADERS }
      );

      const existingUserData = await existingUserResp.json();

      if (existingUserData.records.length > 0) {
        alert("You are already a user.");
        return;
      }

      await fetch(AIRTABLE_URL, {
        method: "POST",
        headers: AIRTABLE_HEADERS,
        body: JSON.stringify({
          fields: {
            phone: userPhone,
            referralby: referralBy || "",
            password: password,
          },
        }),
      });

      console.log("✅ New user added to Airtable");
    } catch (err) {
      console.error("❌ Airtable error:", err);
    }
  };

  return (
    <div style={{ padding: 30, maxWidth: 400, margin: "auto", textAlign: "center" }}>
      <h2>📱 Customer Login</h2>

      <input
        type="tel"
        inputMode="numeric"
        maxLength={10}
        placeholder="Enter your phone number"
        value={phone}
        onChange={(e) => {
          const digitsOnly = e.target.value.replace(/\D/g, "");
          setPhone(digitsOnly);
        }}
        style={inputStyle}
      />

      <input
        type="password"
        placeholder="Create a password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={inputStyle}
      />

      <input
        type="tel"
        inputMode="numeric"
        maxLength={10}
        placeholder="Referral number (optional)"
        value={referralBy}
        onChange={(e) => {
          const digitsOnly = e.target.value.replace(/\D/g, "");
          setReferralBy(digitsOnly);
        }}
        style={inputStyle}
      />

      <button onClick={handleSubmit} style={buttonStyle}>
        Submit
      </button>
    </div>
  );
}

// ✅ Styles
const inputStyle = {
  padding: "10px",
  width: "100%",
  marginBottom: "10px",
  fontSize: "16px",
};

const buttonStyle = {
  padding: "10px 20px",
  backgroundColor: "#007bff",
  color: "white",
  border: "none",
  borderRadius: "5px",
  fontSize: "16px",
  cursor: "pointer",
};
